<template>
  <div>
    <appQuoteViewCom
      :propsData="getQuoteSingle"
      :quoteType="'leads'"
      @callSingleQuote="fnCallSingleQuote()"
    ></appQuoteViewCom>
  </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import appQuoteViewCom from '../../../components/quote/quoteViewCom.vue'
export default {
  name: 'LeadsView',
  components: {
    appQuoteViewCom
  },
  data() {
    return {
      quoteId: this.$route.params.quoteId
    }
  },
  computed: {
    ...mapGetters(['getQuoteSingle'])
  },
  methods: {
    ...mapActions(['fetchQuoteSingle']),
    fnCallSingleQuote: async function () {
      await this.fetchQuoteSingle({
        id: this.quoteId,
        quoteType: 'leads'
      })
    }
  },
  async created() {
    await this.fetchQuoteSingle({
      id: this.quoteId,
      quoteType: 'leads'
    })
  }
}
</script>
